import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { UserProfileService } from '../services/userProfile.service';

export const useCurrentUser = () => {
  const queryKey = ['currentUser'];

  const queryFn = () => UserProfileService.getMyProfile();

  return useQuery({
    queryKey,
    queryFn,
  });
};


export const refreshCurrentUser = () => {
  queryClient.invalidateQueries(['currentUser']);
};
